import { IconClipboardText } from '@tabler/icons-react'
import { Form } from 'antd'

import { CaptureBlockActionButton } from './CaptureBlock.style'

import { NotesInput } from '@/components/form-components/NotesInput'

type NotesEditorProps = {
  notesId: string
  notes: string | false
  editing: boolean
  stopEditing: () => void
}

export const NotesEditor: React.FC<NotesEditorProps> = ({
  notesId,
  notes,
  editing,
  stopEditing,
}) => {
  if (notes === false) return null

  return (
    <Form.Item name={notesId} initialValue={notes} noStyle>
      <NotesInput editing={editing} stopEditing={stopEditing} />
    </Form.Item>
  )
}

type CaptureNotesProps = {
  editing: boolean
  startEditing: () => void
}

export const CaptureNotes: React.FC<CaptureNotesProps> = ({
  editing,
  startEditing,
}) => {
  if (editing) return null

  return (
    <CaptureBlockActionButton
      icon={<IconClipboardText size={12} />}
      onClick={startEditing}
    >
      Notes
    </CaptureBlockActionButton>
  )
}
